import { FC } from 'react';
import { RadioGroupProps } from './types';
import { FormGroup } from '@vtbhome/juicyfront';
import { Typography } from '../typography/typography';
import { Field } from 'react-final-form';
import { RadioWrapper, StyledRadio } from './radio-group.styles';

export const RadioGroup: FC<RadioGroupProps> = ({ name, label, initialValue, fields, onChange }) => {
    return (
        <FormGroup
            label={
                <Typography size='body2_short' color='neutral_50'>
                    {label}
                </Typography>
            }>
            <RadioWrapper>
                {fields.map((field) => (
                    <Field
                        key={field.value}
                        name={name}
                        initialValue={initialValue}
                        value={field.value}
                        type='radio'
                        render={({ input }) => (
                            <StyledRadio
                                {...input}
                                checked={field.checked || input.checked}
                                onChange={onChange || input.onChange}
                                label={field.label}
                            />
                        )}
                    />
                ))}
            </RadioWrapper>
        </FormGroup>
    );
};

RadioGroup.displayName = 'RadioGroup';
